import { Component, DestroyRef,inject } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators, NonNullableFormBuilder } from '@angular/forms';

import { AuthService } from '../../services/auth/auth.service';
import { Router } from '@angular/router';
import { finalize } from 'rxjs';


 
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzMessageService } from 'ng-zorro-antd/message';




@Component({
  selector: 'app-login',
  imports: [ReactiveFormsModule, NzButtonModule, NzFormModule, NzInputModule],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {
  

  signInFormGroup!: FormGroup;

  isLoading = false;
  errorMessage = '';

  constructor(
    private message: NzMessageService,
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private destroyRef: DestroyRef,
    private router: Router
  ) {
    this.signInFormGroup = this.formBuilder.group({
      username: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(8)]]
    });
  }

  createMessage(type: string): void {
    this.message.create(type, `Invalid credentials`);
  }



  onSignInClicked(): void {
    this.isLoading = true;
    const subscription = this.authService.userSignIn(
      this.signInFormGroup.value.username,
      this.signInFormGroup.value.password,
    ).pipe(
      finalize(() => {
        this.isLoading = false;
      })
    ).subscribe({
      next: (response) => {
        this.isLoading = false;
          if(response != null){
            
           // if (response) {
              this.router.navigate(['/dashboard'], {
                replaceUrl: true
              });
            //}
          }else{

            this.createMessage('error');
           
          }


        
      },
    });

    this.destroyRef.onDestroy(() => {
      subscription.unsubscribe();
    });
  }

   

}
